import { useSelector } from 'react-redux';

import useCartStore from './useCartStore';

const useCartPlaylist = (path, type) => {
  const api = useSelector( state => state.api );
  const { addItemsToCart, showModalNoAddToCartDJExlusives } = useCartStore();
  const cartItems = useSelector(state => state.cartItems);
  const isConnected = useSelector(state => state.isConnected);
  const storePopup = useSelector(state => state.storePopup);

  const addPlaylistToCart = () => {
    if (path && isConnected) {
      api.getFromApi(`${path}/tracks/?per_page=100`, false).then( response => {
        const data = (type === `playlists`) ? response.data.results.filter(x => !x.track.is_dj_edit && (x.track.genre && x.track.genre.slug && x.track.genre.slug !== 'dj-exclusives')).map(x => x.track.id) : response.data.results.filter(x => !x.is_dj_edit && (x.genre && x.genre.slug && x.genre.slug !== 'dj-exclusives')).map(x => x.id);      
        let duplicated = data.filter( idSelected => cartItems.find( id => id === idSelected) );
        let items = data.filter( idSelected => !duplicated.includes(idSelected) );

        // DJ Exclusives & Edits
        const exclusives = (type === `playlists`) ? response.data.results.filter(x => x.track.is_dj_edit || (x.track.genre && x.track.genre.slug && x.track.genre.slug === 'dj-exclusives')).map(x => x.track.id) : response.data.results.filter(x => x.is_dj_edit && (x.genre && x.genre.slug && x.genre.slug === 'dj-exclusives')).map(x => x.id);
        if (exclusives.length > 0) {
          showModalNoAddToCartDJExlusives()
        }
        
        addItemsToCart(items, duplicated, cartItems.length);
      } ).catch( e => console.log(`error`, e) );
    } else if (!isConnected) {
      storePopup.cart('.button-add-cart');
    }
  }

  const storeX = {
    addPlaylistToCart
  };

  return storeX;
};

export default useCartPlaylist;
